import comp from "./AITutor";
export default comp;
